<template>
    <ui-PanelOverlay panel="config" :id="`componet_${_uid}`" :show="show" :loading="loading">
        <template v-slot:menuBar>
            <PanelMixinBack></PanelMixinBack>
        </template>
        <template v-slot:body>
            <LocationMenu
                v-if="show"
                :loading.sync="loading"
                :name="$dicc.locationPanel.ubications"
                :navigation="true"
                :edition="true"
                @optionsClick="$emit('optionsClick', $event)"
                @updateLocation="$emit('updateLocation', $event)"
            ></LocationMenu>
        </template>
    </ui-PanelOverlay>
</template>

<script>
    import LocationMenu from '../components/LocationMenu';
    import { PanelMixin } from '../mixins/PanelMixin';

    export default {
        name: 'ConfigLocationPanel',
        mixins: [PanelMixin],
        components: { LocationMenu },
        data() {
            return {
                type: 'config',
            };
        },
    };
</script>
